import React, { Fragment, useEffect } from "react";
import HolderContainer from "../../components/Reusable/HolderContainer";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchBlogList } from "../../actions/blog";
import { Button } from "@mui/material";

import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import Breadcrumb from "../../components/Reusable/Breadcrumb";
import InfoBox from "../../components/Reusable/InfoBox";
import { t } from "i18next"; // Import t function for translation

const Blog = () => {
  const dispatch = useDispatch();
  const { blogList } = useSelector((state) => state.blogReducer);

  useEffect(() => {
    dispatch(fetchBlogList());
  }, [dispatch]);

  return (
    <div className="blog-main-container">
      <Breadcrumb title={t("blog.title")} returnPage="/" />

      <div className="blog-list-container">
        {blogList?.length === 0 ? (
          <InfoBox text={t("blog.noBlogsMessage")} />
        ) : (
          <Fragment>
            {blogList?.map((blog) => {
              return (
                <div key={blog.id} className="blog-list-item">
                  <img src={blog.image} className="img-fluid" alt={blog.name} />
                  <div className="blog-list-item-context">
                    <div className="blog-list-item-title">{blog.name}</div>
                    <div claame="blog-list-item-subtitle">
                      Nudeci mogucnost prelaska sa prozirnog na neprozirni ekran
                    </div>
                    <Link to={`/blog-detail/${blog.id}`}>
                      <div className="button-read-more-blog">
                        {t("blog.readMore")}
                      </div>
                    </Link>
                  </div>
                </div>
              );
            })}
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default Blog;
